module.exports = __webpack_public_path__ + "static/media/barndoor3.94e44c02.jpg";